import {
	BarChartSquare02,
	LogOut01,
	User01,
	ChevronDown,
	Settings01,
} from '@untitledui/icons'
import { useRef } from 'react'
import { Form } from 'react-router'
import { getFullName } from '#app/utils/get-full-name.ts'
import { getUserImgSrc } from '#app/utils/misc.tsx'
import { useIsAdmin, useUser } from '#app/utils/user.ts'
import { AvatarLabelGroup } from './base/avatar/avatar-label-group'
import { Button } from './base/buttons/button'
import { Dropdown } from './base/dropdown/dropdown'

export function UserDropdown() {
	const user = useUser()
	const isAdmin = useIsAdmin()
	const formRef = useRef<HTMLFormElement>(null)

	return (
		<>
			<Dropdown.Root>
				<Button
					className="group"
					color="secondary"
					iconTrailing={ChevronDown}
					aria-label="User menu"
				>
					Account
				</Button>

				<Dropdown.Popover>
					<div className="border-secondary flex gap-3 border-b p-3">
						<AvatarLabelGroup
							size="md"
							src={getUserImgSrc(user.image?.objectKey)}
							title={getFullName(user.firstName, user.lastName)}
							subtitle={user.email}
						/>
					</div>
					<Dropdown.Menu>
						<>
							<Dropdown.Item href="/dashboard" icon={BarChartSquare02}>
								Dashboard
							</Dropdown.Item>
							<Dropdown.Item href="/settings/profile" icon={User01}>
								View profile
							</Dropdown.Item>
							{isAdmin && (
								<Dropdown.Item href="/admin" icon={Settings01}>
									Admin
								</Dropdown.Item>
							)}
							<Dropdown.Item
								icon={LogOut01}
								onClick={() => formRef.current?.submit()}
							>
								Log out
							</Dropdown.Item>
						</>
					</Dropdown.Menu>
				</Dropdown.Popover>
			</Dropdown.Root>
			<Form action="/logout" method="POST" ref={formRef}></Form>
		</>
	)
}
